module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAgCAMAAAAG5/lRAAAANlBMVEUAAADMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMw+rbMAAAAAEXRSTlMA7xP15LKrgHtjMyoD0tGZmFiIdt0AAABUSURBVAjXjY85DgAxCMQGcodc/P+zGyS2jxs3IHkwClEZqHqpiKaIYApIpgSZqlMAbo3xRu8AOKtmxtHLAZno1zZtP/GHFzxCluoSD/Rcj/cpPuwDYYAFcaaQ01MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/三个圆点@2x.png
// module id = 1UU/
// module chunks = 0